"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('Search', function (props) {
  return _react.default.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("circle", {
    fill: "transparent",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin,
    cx: "21",
    cy: "21",
    r: "17"
  }), _react.default.createElement("path", {
    d: "M26.6568542,14.3431458 C25.209139,12.8954305 23.209139,12 21,12 C18.790861,12 16.790861,12.8954305 15.3431458,14.3431458",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M31.4644661,37.4644661 L43.4644661,37.4644661",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(37.464466, 37.464466) rotate(45.000000) translate(-37.464466, -37.464466)"
  }))));
});

exports.default = _default;